import { chakra, type HTMLChakraProps, type RecipeProps, useRecipe } from '@chakra-ui/react/styled-system';
import { forwardRef } from 'react';

import { IconCross } from '../../icons';
import BitkitLabelTooltip from '../BitkitLabelTooltip/BitkitLabelTooltip';

export interface BitkitCloseButtonProps
  extends Omit<HTMLChakraProps<'button'>, 'colorPalette'>, RecipeProps<'closeButton'> {
  /**
   * Hover label for the button. Defaults to `aria-label` — set it when the accessible name is
   * too long to read well as a tooltip.
   */
  tooltipText?: string;
}

const BitkitCloseButton = forwardRef<HTMLButtonElement, BitkitCloseButtonProps>((props, ref) => {
  const { 'aria-label': ariaLabel = 'Close', size = 'xs', colorVariant, css, tooltipText, ...rest } = props;

  const style = useRecipe({ key: 'closeButton' });

  return (
    <BitkitLabelTooltip disabled={rest.disabled} text={tooltipText ?? ariaLabel}>
      <chakra.button
        ref={ref}
        aria-label={ariaLabel}
        {...rest}
        css={[style({ size, colorVariant }), css]}
        color={colorVariant === 'neutral' && !rest.disabled ? 'icon/primary' : undefined}
      >
        <IconCross size={size === 'xs' ? '16' : '24'} />
      </chakra.button>
    </BitkitLabelTooltip>
  );
});

BitkitCloseButton.displayName = 'BitkitCloseButton';

export default BitkitCloseButton;
